import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getDeliveryConfig = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/delivery-config`);
    if (response.data.status === 200) {
      return response.data.data;
    }
    throw new Error('Failed to fetch delivery config');
  } catch (error) {
    console.error('Error fetching delivery config:', error);
    return null;
  }
};
